<div class="login_bg">
        <!-- Form Section Start -->
        <div class="inner_container"> 
            <div class="login_form_wrapper">
                <div class="login_form_bg"><a href="index.html" class="logo" title="ManpowerGroup logo"></a></div>
                <div class="login_form">
                    <div class="login_header_right">
                        <h1>{{'ForgotPassword.TITLE' | translate}}</h1>
                        
                    </div>
                    <!-- Login form Start-->
                    <form [formGroup]="forgotPwd">
                        <div class="mb-4">
                            <label for="userName" class="form-label">{{'USERID' | translate}}</label>
                            <div class="input-group login_id">
                                <input type="text" class="form-control" id="loginID" formControlName="loginID"
                                name="loginID" required aria-describedby="login_id" placeholder="{{'USERID' | translate}}">
                                <span><i class="bi bi-person"></i></span>
                                <small *ngIf="forgotPwd.controls['loginID'].dirty && forgotPwd.hasError('required','loginID')" class="text-danger mt-1">*{{"ForgotPassword.err1" | translate}}</small>
                            </div>
                        </div>
                        <div class="mb-4">
                            <label for="password" class="form-label">{{'ForgotPassword.EMAIL' | translate}}</label>
                            <div class="input-group login_id">
                                <input type="email" class="form-control" formControlName="email" name="email" aria-describedby="login_password" placeholder="{{'ForgotPassword.EMAIL' | translate}}">
                                <span><i class="bi bi-envelope"></i></span>
                                <small *ngIf="forgotPwd.controls['email'].dirty && forgotPwd.hasError('required','email')" class="text-danger mt-1">*{{"ForgotPassword.err2" | translate}}</small>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col"><button type="button" class="btn btn-primary login" (click)="sendPwd()">{{'ForgotPassword.SENDLINK' | translate}}</button></div>
                            <div class="col text-end">
                                <a href="login" class="forgot_password">{{'ForgotPassword.BACKTOLOGIN' | translate}}</a>
                            </div>
                        </div>
                    </form>
                    <!-- Login form Start-->

                </div>
            </div>
        </div>
        <!-- Form Section End -->
</div>         
